const ColorsTheme = {
  light: {
    background: "#ffffff",
    color: "#000000"
  },
  dark: {
    background: "#101426",
    color: "#ffffff"
  }
};

export default ColorsTheme;
